export enum AttributeType {
  Text = 0,
  Numeric = 1,
  Date = 2,
  Boolean = 3,
}
